"use client";

/**
 * LocationShipStrip — shows "Shipping to <name> · −<N>%" at the top of the
 * cart drawer and the /cart page's line-list card.
 *
 * Visibility rules:
 *  - Hidden when no location is active (anonymous / no default set).
 *  - Discount segment (` · −N%`) hidden when `discount_percent === 0`.
 *
 * The component is a leaf client component so it can be embedded in the
 * server-rendered CartPage without converting the whole page.
 */

import { useActiveLocation } from "../src/hooks/useActiveLocation";

export function LocationShipStrip() {
  const activeLoc = useActiveLocation();

  if (!activeLoc) return null;

  return (
    <div className="border-b border-ink-100 bg-paper-warm px-4 py-2 text-body-sm text-ink-700">
      Shipping to {activeLoc.name}
      {activeLoc.discount_percent > 0 && (
        <span className="text-accent-deep"> · −{activeLoc.discount_percent}%</span>
      )}
    </div>
  );
}
